import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { useAddEditContractTypesDialogHooks } from "./AddEditContractTypeDialog.hooks";
import { ContractTypeViewModel } from "../contractTypes/ContractType.types.ts";

export interface IAddEditContractTypeDialogProps {
    onDialogClose: () => void;
    isAdd: boolean;
    ContractTypeToUpdate: ContractTypeViewModel | undefined;
    onSaved: () => void;
}

function AddEditContractTypeDialog(props: IAddEditContractTypeDialogProps) {
    const { translateString } = useTranslation();
    const { isSaving, onModelChange, onSave, saveModel, validation } = useAddEditContractTypesDialogHooks(props);

    return (
        <DotLegalDialog
            size="sm"
            inProgress={isSaving}
            header={props.isAdd ? translateString("createContractType") : translateString("editContractType")}
            buttonOkText={props.isAdd ? translateString("create") : translateString("save")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onSave}
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
                onChange={(name) => onModelChange((model) => (model.name = name))}
            />
        </DotLegalDialog>
    );
}

export default AddEditContractTypeDialog;
